import log, { type LogLevelDesc } from 'loglevel';
import { token } from '@/infrastructure/container';

export interface ILogger {
  trace(...args: unknown[]): void;
  debug(...args: unknown[]): void;
  info(...args: unknown[]): void;
  warn(...args: unknown[]): void;
  error(...args: unknown[]): void;
  setLevel(level: LogLevelDesc): void;
}

export const TOKEN_ILogger = token<ILogger>('ILogger');

export class Logger implements ILogger {
  constructor() {
    log.setLevel(import.meta.env.PROD ? 'error' : 'info');
  }

  trace(...args: unknown[]): void {
    log.trace(...args);
  }
  debug(...args: unknown[]): void {
    log.debug(...args);
  }
  info(...args: unknown[]): void {
    log.info(...args);
  }
  warn(...args: unknown[]): void {
    log.warn(...args);
  }
  error(...args: unknown[]): void {
    log.error(...args);
  }
  setLevel(level: LogLevelDesc): void {
    log.setLevel(level);
  }
}

export class SilentLogger implements ILogger {
  trace(..._args: unknown[]): void {}
  debug(..._args: unknown[]): void {}
  info(..._args: unknown[]): void {}
  warn(..._args: unknown[]): void {}
  error(..._args: unknown[]): void {}
  setLevel(_level: LogLevelDesc): void {
    void _level;
  }
}
